import * as widgetConstants from './constants';

export const embedSettings = {
    [widgetConstants.LANGUAGE]: null,
    [widgetConstants.WIDGET_FONT]: '',
    [widgetConstants.IS_REGISTRATION_TITLE_HIDDEN]: false,
    [widgetConstants.IS_LABELS_HIDDEN]: false,
    [widgetConstants.IS_PLACEHOLDERS_VISIBLE]: true,
    [widgetConstants.IS_REGISTRATION_TEXT_HIDDEN]: false,
    [widgetConstants.IS_CONFIRMATION_TITLE_HIDDEN]: false,
    [widgetConstants.IS_CONFIRMATION_TEXT_HIDDEN]: false,
    [widgetConstants.IS_LOGO_HIDDEN]: false,
    [widgetConstants.IS_CALENDAR_VISIBLE]: true,
    style: {
        [widgetConstants.THEME_COLOR_ACCENT]: '',
        [widgetConstants.THEME_COLOR_DARK]: '',
        [widgetConstants.THEME_COLOR_LIGHT]: '',
    },
};

export const themeColorTitles = {
    [widgetConstants.THEME_COLOR_ACCENT]: 'Акцентный цвет',
    [widgetConstants.THEME_COLOR_DARK]: 'Темный цвет',
    [widgetConstants.THEME_COLOR_LIGHT]: 'Светлый цвет',
};

export const languageOptions = {
    [widgetConstants.LANG_RU]: 'Русский',
    [widgetConstants.LANG_EN]: 'Английский',
};

export const colorThemeOptions = {
    [widgetConstants.THEME_LIGHT]: 'Светлая',
    [widgetConstants.THEME_DARK]: 'Темная', 
};

export const yandexMetricaGoals = [
    {
        label: 'loadedForm',
        action: 'Просмотр формы виджета регистрации',
        goal: '[COMDI] widget loaded form',
    },
    {
        label: 'editedField',
        action: 'Заполнены все поля виджета регистрации',
        goal: '[COMDI] widget edited field',
    },
    {
        label: 'clickedButton',
        action: 'Нажата кнопка виджета «Регистрация» или «Подать заявку»',
        goal: '[COMDI] widget clicked button',
    },
    {
        label: 'requestSuccess',
        action: 'Завершение регистрации - «Заявка принята»',
        goal: '[COMDI] widget request success',
    },
    {
        label: 'registrationSuccess',
        action: 'Завершение регистрации - «Регистрация пройдена успешно»',
        goal: '[COMDI] widget registration success',
    },
];
